import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

// TODO: replace with good copy.
const Intro = ({ onClick }) => (
  <div className="campaign-intro">
    <h1>What is Tabby Rewards?</h1>
    <p>
      Tabby Rewards is a smart contract which enables teams to generate a large quantity of
      distribution codes without requiring a list of addresses. With Tabby Rewards, your
      team can quickly and easily distribute promotional tokens via unique, redeemable URLs. This smart
      contract will save your team time and money and open a novel marketing avenue.
    </p>
    <div className="actions">
      <button className="btn" type="button" name="continue" onClick={() => onClick()}>
        Create Campaign
      </button>
    </div>
  </div>
);

Intro.defaultProps = {
  onClick: noop,
};

Intro.propTypes = {
  onClick: PropTypes.func,
};

export default Intro;



// WEBPACK FOOTER //
// ./src/containers/createCampaign/Intro.js